/*
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

export const MIN_SEARCH_TEXT_LENGTH = 3;
